import _regeneratorRuntime from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
var _hoisted_1 = {
  class: "bottom-nav"
};
var _hoisted_2 = ["onClick"];
var _hoisted_3 = ["src"];
var _hoisted_4 = {
  class: "label"
};
import { useRouter } from "@/hooks/useRouter";
import { useOrder } from "@/hooks/useOrder";
import { useSupplierStore } from "@/store/supplierStore";
import { computed } from "vue";
import SvgIcon from "@/components/base/SvgIcon.vue";
import { useI18n } from "vue-i18n";
export default {
  __name: 'BottomNav',
  setup: function setup(__props) {
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var supplierStore = useSupplierStore();
    var _useOrder = useOrder(),
      toOrderView = _useOrder.toOrderView;
    var routerNameMap = {
      home: "Index",
      menu: "Menu",
      orders: "Orders",
      rewards: "Rewards",
      account: "Account"
    };
    var defaultIconMap = {
      Index: {
        icon: "home",
        iconActived: "home_selected"
      },
      Menu: {
        icon: "menu",
        iconActived: "menu_selected"
      },
      Orders: {
        icon: "orders",
        iconActived: "orders_selected"
      },
      Rewards: {
        icon: "rewards",
        iconActived: "rewards_selected"
      },
      Account: {
        icon: "account",
        iconActived: "account_selected"
      }
    };
    var navs = computed(function () {
      var arr = supplierStore.getBottomNavSetting;
      if (!arr.length) {
        return [{
          label: t("home"),
          value: "Index"
        }, {
          label: t("menu"),
          value: "Menu",
          query: {
            type: "self_pick_up"
          }
        }, {
          label: t("orders"),
          value: "Orders"
        }, {
          label: t("rewards"),
          value: "Rewards"
        }, {
          label: t("account"),
          value: "Account"
        }];
      }
      return arr.map(function (item) {
        return {
          label: item.text,
          value: routerNameMap[item.item_type],
          icon: item.unselected_image.image_url,
          iconActived: item.selected_image.image_url
        };
      });
    });
    var _useRouter = useRouter(),
      routerPush = _useRouter.routerPush,
      router = _useRouter.router;
    var changeTab = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(name, query) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = name;
              _context.next = _context.t0 === "Menu" ? 3 : 5;
              break;
            case 3:
              // menu特殊处理
              toOrderView();
              return _context.abrupt("break", 7);
            case 5:
              // 普通逻辑
              routerPush({
                name: name,
                query: query
              });
              return _context.abrupt("break", 7);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function changeTab(_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("nav", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navs.value, function (item) {
        var _defaultIconMap$item$, _defaultIconMap$item$2;
        return _openBlock(), _createElementBlock("div", {
          key: item.value,
          class: _normalizeClass(["item", {
            active: _unref(router).currentRoute.value.name === item.value
          }]),
          style: _normalizeStyle({
            width: 100 / navs.value.length + '%'
          }),
          onClick: function onClick($event) {
            return changeTab(item.value, item.query);
          }
        }, [item.icon ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _unref(router).currentRoute.value.name === item.value ? item.iconActived : item.icon,
          alt: ""
        }, null, 8, _hoisted_3)) : (_openBlock(), _createBlock(SvgIcon, {
          key: 1,
          class: "icon",
          name: _unref(router).currentRoute.value.name === item.value ? (_defaultIconMap$item$ = defaultIconMap[item.value]) === null || _defaultIconMap$item$ === void 0 ? void 0 : _defaultIconMap$item$.iconActived : (_defaultIconMap$item$2 = defaultIconMap[item.value]) === null || _defaultIconMap$item$2 === void 0 ? void 0 : _defaultIconMap$item$2.icon,
          size: "24"
        }, null, 8, ["name"])), _createElementVNode("div", _hoisted_4, _toDisplayString(item.label), 1)], 14, _hoisted_2);
      }), 128))]);
    };
  }
};